import { ToggleGroup, ToggleGroupItem } from "@aisquare/ui";
import {
  AlignCenterIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
} from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function ToggleGroupDemo() {
  return (
    <Section
      id="toggle-group"
      title="ToggleGroup"
      description="Segmented selector in the Onyx notch language — each item is a notched chip face (nx-t) with a continuous nx-rim keyline and the shared springy 1px press-DOWN; the pressed segment reads as the accent fill. type=single (radio) or type=multiple (checkbox)."
    >
      <VariantBlock label="Single (radio-style)">
        <ToggleGroup type="single" defaultValue="left">
          <ToggleGroupItem value="left" aria-label="Align left">
            <AlignLeftIcon />
          </ToggleGroupItem>
          <ToggleGroupItem value="center" aria-label="Align center">
            <AlignCenterIcon />
          </ToggleGroupItem>
          <ToggleGroupItem value="right" aria-label="Align right">
            <AlignRightIcon />
          </ToggleGroupItem>
          <ToggleGroupItem value="justify" aria-label="Justify">
            <AlignJustifyIcon />
          </ToggleGroupItem>
        </ToggleGroup>
      </VariantBlock>

      <VariantBlock label="Multiple (checkbox-style)">
        <ToggleGroup type="multiple" defaultValue={["bold"]}>
          <ToggleGroupItem value="bold">B</ToggleGroupItem>
          <ToggleGroupItem value="italic">I</ToggleGroupItem>
          <ToggleGroupItem value="underline">U</ToggleGroupItem>
        </ToggleGroup>
      </VariantBlock>

      <VariantBlock label="Outline variant + small size">
        <ToggleGroup
          type="single"
          variant="outline"
          size="sm"
          defaultValue="grid"
        >
          <ToggleGroupItem value="grid">Grid</ToggleGroupItem>
          <ToggleGroupItem value="list">List</ToggleGroupItem>
          <ToggleGroupItem value="timeline">Timeline</ToggleGroupItem>
        </ToggleGroup>
      </VariantBlock>
    </Section>
  );
}
